import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface EmptyStateProps {
  /**
   * Fallback icon to display when no imageURL is provided.
   */
  icon?: SvgIconComponent;
  /**
   * The main message shown below the visual element.
   */
  message: string;
  /**
   * Size in pixels for the icon or image. Defaults to 64.
   */
  iconSize?: number;
  /**
   * Optional URL of an image to display instead of the icon.
   * When provided, the image takes precedence over the icon.
   */
  imageURL?: string;
  /**
   * Additional styling overrides for the root Box component.
   */
  sx?: SxProps<Theme>;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  message,
  iconSize = 64,
  imageURL,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 3,
        ...sx,
      }}
    >
      {imageURL ? (
        <Box
          component="img"
          src={imageURL}
          alt="empty-state"
          sx={{
            maxWidth: '80%',
            maxHeight: '80%',
            objectFit: 'contain',
          }}
        />
      ) : (
        Icon && <Icon
          sx={{
            fontSize: iconSize,
            color: 'text.disabled',
            mb: 2,
          }}
        />
      )}
      <Typography
        variant="body1"
        color="text.secondary"
        align="center"
        sx={{ whiteSpace: 'pre-line' }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyState;